import { render, staticRenderFns } from "./message-comp.vue?vue&type=template&id=10df39da&"
import script from "./message-comp.vue?vue&type=script&lang=js&"
export * from "./message-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports